import * as React from 'react';
import { useState, useEffect } from "react";

import {
  Datagrid,
  DateField,
  List,
  SimpleShowLayout,
  TextField,
  useRecordContext,
  Show, SelectField, TopToolbar, useRefresh, useRedirect,
} from "react-admin";
import { typesOfNotif } from "../../../constants/choices"
import { ColoredChipFieldStatus } from '../../custom/ColoredChipFieldStatus';
import IconMarkChatRead from '@mui/icons-material/MarkChatRead';
import { SERVER } from '../../../constants';
import { AUTH_TYPES } from '../../../auth/authConstants';
import { ExitToApp } from "@material-ui/icons";
import { Link } from 'react-router-dom';
import { Button } from '@mui/material';
import { isMobile, } from 'react-device-detect';

const ListActions = () => {

  const refresh = useRefresh();
  const [notificationsData, setNotificationsData] = useState({ notifications: [] })

  const urlNotif = `${SERVER}/admin/notificationsupdateread`;
  const token = localStorage.getItem(AUTH_TYPES.AUTHORIZATION);

  function markAsRead() {
    fetch(urlNotif
      , {
        headers: new Headers({
          'Authorization': `${token}`,
        }),
      })
      .then((data) => data)
      // .then((data) => setTableRows(data.rows))
      .then((data) => setNotificationsData(data))
      // .then((data) => tableColumns= data.columns)
      .then((date) => {
        // alert('تمامی اعلان‌ها خوانده شد')
        refresh();
      })
  }
  useEffect(() => {

    const interval = setInterval(() => refresh(), 5000)
    return () => {
      clearInterval(interval);

    }
  }, [notificationsData ,refresh])

  return (
    <TopToolbar>
      {/* Add your custom actions */}
      <Button
        onClick={(e) => { e.preventDefault(); e.stopPropagation(); markAsRead() }}
        label="خواندن همه"
      >
        <IconMarkChatRead />  خواندن همه
      </Button>
    </TopToolbar>
  )
};
// const postRowStyle = (record, index) => {
//   let userId = localStorage.getItem("userId")
//   const unread = record.users.find(a => a.userId === userId).unread;

//   return(
//     {backgroundColor: unread === true ? '#f09292':'#66f26f',}
//   )
// };
export const NotificationsList = (props) => {
  return (

    <List {...props} perPage={25} sort={{ field: 'updatedAt', order: 'DESC' }} actions={<ListActions />}>
      {isMobile ? (
        <Datagrid  rowClick="show" sort={{ field: 'createdAt', order: 'DESC' }}>
          <ColoredChipFieldStatus source="unread" color="primary" label=""/>

          <TextField source="title" style={{ 'whiteSpace': "pre-wrap" }}  rows={5}  />

          <SelectField source="type" choices={typesOfNotif} />
          <GotoPageButton text=""/>
        </Datagrid>
      ) : (
        <Datagrid rowClick="show" sort={{ field: 'createdAt', order: 'DESC' }}>
          <ColoredChipFieldStatus source="unread" color="primary" label=""/>

          <TextField source="title" style={{ 'whiteSpace': "pre-wrap" }}  rows={5}  />

          <TextField source="content"  style={{ 'whiteSpace': "pre-wrap",width:"100px"  }}    />
          <SelectField source="type" choices={typesOfNotif} />
          <DateField locales={"fa-IR"} source="createdAt" options={{ year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit' }} />
          <GotoPageButton text="بیشتر"/>
        </Datagrid>

      )}

    </List>
  )
};


export const NotificationsShow = (props) => {
  return (
    <Show {...props} actions={null}>
      <SimpleShowLayout>
        <TextField source="title" label="عنوان " style={{ 'whiteSpace': "pre-wrap" }}  rows={5} />
        <TextField source="content" label="متن پیام" style={{ 'whiteSpace': "pre-wrap" }}  rows={5} />

        <SelectField source="type" choices={typesOfNotif} />
        <DateField locales={"fa-IR"} source="createdAt" />
        <GotoPageButton text="نمایش "/>
      </SimpleShowLayout>
    </Show>
  )
};
const GotoPageButton = (props) => {
  const record = useRecordContext();
  record.url = record.url?.replace('#/', '');
  const redirect = useRedirect();
  function handleDetail() {
    redirect(record.url);
  }
  return (
    <Button

      endIcon={<ExitToApp style={{ marginRight: "8px" }} />}
      color="secondary" variant="outlined"
      component={Link}
      style={{ margin: "4px" }}
      onClick={(e) => { e.preventDefault(); e.stopPropagation(); handleDetail() }}

    // to={{
    //   pathname: record.url,
    // }}
    >  {props.text}
    </Button>
  )
};

// export const NotificationsCreate = (props) => (
//   <CreateView {...props}>
//     <BooleanInput source="sendToAll" label="ارسال به همه" />
//     <FormDataConsumer>
//       {({ formData, ...rest }) => !formData.sendToAll && <div>
//         <ReferenceArrayInput source="users" label="همکاران" reference="adminUsers">
//           {/* <SelectInput optionText="title" style={{ float: 'right', marginLeft: '10px', width: '70%' }} /> */}
//           <AutocompleteArrayInput variant="outlined" source="name" optionText="name" />
//         </ReferenceArrayInput >
//       </div>
//       }
//     </FormDataConsumer>
//     <TextInput source="content" label="متن پیام"
//     inputProps={{
//       maxLength: 100,
//     }}
//     multiline rows={5} validate={required()} />
//   </CreateView>
// );
